import { useEffect, useRef, useState } from "react";
import { useDebounce } from "./lib";
import { useMutation } from "@tanstack/react-query";
import { closeAggr } from "../../../Services/Api";
import useSound from "use-sound";
import err from '../sounds/err.mp3';
import saveSucsess from '../sounds/saveSucsess.mp3';
import { TextField, Typography } from "@mui/material";


export const Stage3 = (props) => {
  const {
    setRezult = () => { },
    aggrCode,
    kms,
    productDate,
    barCode,
    order,
    autocomplete,
    withoutAgregation,
    boxSize,
    aggLevelId, 
    // saveProductDate = () => { }
  } = props;
  const [playErr] = useSound(err);

  const codeFieldRef = useRef(null);
  const dateRef = useRef(null);
  const [code, setCode] = useState((autocomplete || withoutAgregation) ? aggrCode : '');
  const [date, setDate] = useState(productDate);
  const [errorMessage, setErrorMessage] = useState('');
  console.log('!!!Stage3', productDate, date)
  const clear = () => {
    setCode('');
    if (codeFieldRef.current) {
      codeFieldRef.current.focus();
    }
  }
  useEffect(() => {
    if (!autocomplete && !withoutAgregation) clear();
    setErrorMessage('');
  }, []);

  const mutation = useMutation({
    mutationFn: closeAggr,
    onSuccess: (data) => {
      if (data?.payload?.status === 'ok') {
        setRezult();
      } else {
        clear();
        setErrorMessage(data?.payload?.resultMessage || 'Ошибка проверки кода');
        playErr();
      }
      // console.log('!!!Code check successful:', data?.payload?.status);
    },
    onError: (error) => {
      playErr();
      // console.error('!!!Code check failed:', error);
      clear();
      setErrorMessage(error?.message ? (`Сетевая ошибка: ${error.message}`) : 'Непредвиденная сетевая ошибка');
    },
  });

  useDebounce(code, 200, (value) => {
    if (value) {
      if (value !== aggrCode) {
        playErr();
        setErrorMessage(`Отсканированный код ("${value}") не совпадает с агрегационным кодом ("${aggrCode}")`);
        clear();
      } else {
        // playSaveSucsess();
        setErrorMessage('');
        mutation.mutate({ aggrCode, kms, prodDate: date, barCode, order, boxSize, aggLevelId});
        // if (dateRef.current) {
        //   dateRef.current.focus();
        // }
      }
    }
  });

  // const onSaveClick = () => {
  //   mutation.mutate({ aggrCode, kms, prodDate: date });
  // }


  return (
    <div >
      <div style={{ height: "20px", width: '100%', backgroundColor: "#22EE77" }} >3</div>
      <Typography variant="body1" gutterBottom>
        Заершение упаковки: Отсканируйте код упаковки
      </Typography>
      <div >
        <TextField
          inputRef={codeFieldRef}
          InputLabelProps={{ shrink: true }}
          label="Код упаковки"
          fullWidth
          size="small"
          value={code}
          onChange={(e) => setCode(e?.target?.value || e)}
          error={!!errorMessage}
          helperText={!!errorMessage ? errorMessage : undefined}
        />
      </div>
      {/* <div >
        {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
        <input
          style={{ width: "100%" }}
          ref={codeFieldRef}
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Отсканируйте Агрегационный код"
        />


      </div> */}
    </div >
  );
}